module.exports = __webpack_public_path__ + "img/24gf-playCircle.16da2b60.png";